// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"57b62e1a","480":"0e4b740d","481":"0e4b740d"}[chunkId] + ".chunk.css";
};